// extracted by mini-css-extract-plugin
export default {"good":"tracker-attributes_good__36IOf","medium":"tracker-attributes_medium__2rLo7","bad":"tracker-attributes_bad__E0Faj"};